import { FETCH_STCK_UNITS_LIST, RECEIVE_STCK_UNITS_LIST, FAILED_STCK_UNITS_LIST } from '../../actions/stocker/stck.units.act'

const defaultStckUnitsState = {
    stckUnitsData: [],
    stckTotalUnits: 0,
    stckUnitsSelect: [],
    success: true,
    inProgress: false,
}

export function StckUnits(state = defaultStckUnitsState, action){
    switch (action.type) {
        case FETCH_STCK_UNITS_LIST:
            return ({stckUnitsData: [], success: true, stckTotalUnits: 0, stckUnitsSelect: [], inProgress: true})
        case RECEIVE_STCK_UNITS_LIST:
            var _totalUnits = action.payload.result.length;
            var _stckUnitsSelect = []
            if(action.payload.result !== []) {
                var _unitsData = action.payload.result

                _unitsData.forEach((p, index) => {
                    var _loc = {
                        'label': _unitsData[index].unit_name + ' (' + _unitsData[index].unit_symbol + ')',
                        'value': _unitsData[index].id
                    }
                    _stckUnitsSelect.push(_loc)
                })
            }
            return Object.assign({}, state, {stckUnitsData: action.payload, success: true, stckTotalUnits: _totalUnits, stckUnitsSelect: _stckUnitsSelect, inProgress: false})
        case FAILED_STCK_UNITS_LIST:
            return ({stckUnitsData: [], success: false, stckTotalUnits: 0, stckUnitsSelect: [], inProgress: false})
        default:
            return state
    }
}